/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingRqDto } from './traveline-booking-rq-dto';
import {
    TravelineBookingRqDtoFromJSON,
    TravelineBookingRqDtoFromJSONTyped,
    TravelineBookingRqDtoToJSON,
    TravelineBookingRqDtoToJSONTyped,
} from './traveline-booking-rq-dto';

/**
 * Checking possibility of booking creation
 * @export
 * @interface TravelineVerifyBookingRequestDto
 */
export interface TravelineVerifyBookingRequestDto {
    /**
     * 
     * @type {TravelineBookingRqDto}
     * @memberof TravelineVerifyBookingRequestDto
     */
    booking?: TravelineBookingRqDto;
}

/**
 * Check if a given object implements the TravelineVerifyBookingRequestDto interface.
 */
export function instanceOfTravelineVerifyBookingRequestDto(value: object): value is TravelineVerifyBookingRequestDto {
    return true;
}

export function TravelineVerifyBookingRequestDtoFromJSON(json: any): TravelineVerifyBookingRequestDto {
    return TravelineVerifyBookingRequestDtoFromJSONTyped(json, false);
}

export function TravelineVerifyBookingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineVerifyBookingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'booking': json['booking'] == null ? undefined : TravelineBookingRqDtoFromJSON(json['booking']),
    };
}

  export function TravelineVerifyBookingRequestDtoToJSON(json: any): TravelineVerifyBookingRequestDto {
      return TravelineVerifyBookingRequestDtoToJSONTyped(json, false);
  }

  export function TravelineVerifyBookingRequestDtoToJSONTyped(value?: TravelineVerifyBookingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking': TravelineBookingRqDtoToJSON(value['booking']),
    };
}

